import useSWR from 'swr'
import API from '../../../utils/api'
import { getPersistData } from '../../hooks/persist'
import { useToken } from 'app/hooks'

const KEY = '/users?page=1&maxData=1000&usertype=' // (1) 사용자 목록 조회 2: 강사, 3: 학생

// Keep a per-key cache to avoid cross-usertype contamination.
let swrDataByKey: Record<string, any> = {}

export function useTeacherStudent(usertype) {
	const { data: token } = useToken()
	const swrKey = KEY + usertype
	if (!(swrKey in swrDataByKey)) {
		swrDataByKey[swrKey] = getPersistData(swrKey)
	}
	const { data, mutate } = useSWR<any>(
		swrKey,
		async (url) => {
			const response = await API.get(url, token + '', {})
			swrDataByKey[swrKey] = response.result?.result?.list

			return swrDataByKey[swrKey]
		},
		{ revalidateOnFocus: true }
	)

	return {
		TeacherStudentData: data,
		mutate: (value?: any) => {
			if (value != undefined) {
				swrDataByKey[swrKey] = value
			}
			return mutate()
		},
	}
}
